<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: error_msg }" :type="type" :value="value"
           @input="onInput($event.target.value)"
    />
    <div v-if="error_msg" class="form-error">{{ error_msg }}</div>
  </div>
</template>

<script>
import {v4 as uuid} from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    value: String,
  },
  emits: ['input'],
  data: function () {
    return {
      error_msg: '',
    }
  },
  watch: {
    error: function (val) {
      this.error_msg = val
    },
  },
  methods: {
    onInput: function (value) {
      this.error_msg = ''
      this.$emit('input', value)
    },
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
